import moment from 'moment';
import router from '@/router';
import { instBundle } from '@/axios.js';

const axiosAdmin2 = instBundle.axiosAdmin2;

const _initImg = list => {
	return list.map(setList =>
		setList.map(item => {
			item.src = '';
			return item;
		})
	);
};

const _setImg = (list, data) => {
	return list.map(setItem => {
		return setItem.map(item => {
			if (data[item.id]) item.src = data[item.id];
			return item;
		});
	});
};

const state = {
	title: '',
	isReservedList: [
		{ value: 0, name: '상시노출' },
		{ value: 1, name: '예약노출' },
	],
	isReserved: 0,
	reservedFrom: '',
	reservedTo: '',
	isConnectPopupList: [
		{ value: 1, name: '연결함' },
		{ value: 0, name: '연결안함' },
	],
	isConnectPopup: 0,
	idPopup: null,
	selectedPopupValue: '',
	selectedPopup: null,
	getReady: false,
	id: null,
	aosList: [
		[
			{
				id: 'aos10802640',
				src: '',
				label: 'Android 1080 X 2640',
				w: 1080,
				h: 2640,
			},
			{
				id: 'aos14403000',
				src: '',
				label: 'Android 1440 X 3000',
				w: 1440,
				h: 3000,
			},
			{
				id: 'aos14403200',
				src: '',
				label: 'Android 1440 X 3200',
				w: 1440,
				h: 3200,
			},
		],
	],
	iosList: [
		[
			{
				id: 'ios8p',
				src: '',
				label: 'iPhone 8+ (1242 X 2208)',
				w: 1242,
				h: 2208,
			},
			{
				id: 'iosxs',
				src: '',
				label: 'iPhone xs (1125 X 2436)',
				w: 1125,
				h: 2436,
			},
		],
	],
};

const getters = {
	getAllTypeList(state) {
		return [
			{
				id: 'aos',
				os: 'Android',
				title: '- Android 스플래시 이미지',
				list: state.aosList,
			},
			{
				id: 'ios',
				os: 'iOS',
				title: '- iOS 스플래시 이미지',
				list: state.iosList,
			},
		];
	},
	imgHasEmpty(state, getters) {
		let msg = '';
		const hasInvalid = getters.getAllTypeList.some(osItem => {
			return osItem.list.some((setList, setIdx) => {
				const hasImgList = setList.filter(item => item.src);
				if (
					!(
						hasImgList.length === setList.length ||
						hasImgList.length < 1
					)
				) {
					msg = `'${osItem.os} 세트 ${setIdx + 1}' 의 이미지를 모두 등록 해주세요.`;
					return true;
				} else {
					return false;
				}
			});
		});
		return hasInvalid ? msg : false;
	},
	validation: (state, getters) => test => {
		try {
			let msg;
			if (!state.title) throw '제목을 입력하세요.';
			if (
				state.isReserved === 1 &&
				(!state.reservedFrom || !state.reservedTo)
			)
				throw '노출기간을 설정하세요.';
			if (state.isConnectPopup === 1) {
				if (!state.idPopup) throw '연결할 시작팝업을 선택해주세요.';
				const splashStart = state.reservedFrom;
				const splashEnd = state.reservedTo;
				const popStart = moment(
					state.selectedPopup.startDate,
					'YYYY-MM-DD HH:mm'
				).format('YYYYMMDDHHmmSS');
				const popEnd = moment(
					state.selectedPopup.endDate,
					'YYYY-MM-DD HH:mm'
				).format('YYYYMMDDHHmmSS');
				if (
					state.isReserved === 1 &&
					((!popEnd && popStart >= splashEnd) ||
						splashEnd <= popStart ||
						(!!popEnd && splashStart >= popEnd))
				) {
					throw '연결할 시작팝업의 노출기간을 확인해주세요.';
				}
			}
			if ((msg = getters.imgHasEmpty)) throw msg;
		} catch (msg) {
			alert(msg);
			return false;
		}
		if (!confirm('스플래시 이미지를 등록하시겠습니까?')) {
			return false;
		}
		return true;
	},
	getParams: state => nickName => {
		const params = {
			id: state.id,
			title: state.title,
			isReserved: state.isReserved,
			nickName,
			isConnectPopup: state.isConnectPopup,
		};
		if (state.isReserved) {
			params.reservedFrom = state.reservedFrom
				? moment(state.reservedFrom, 'YYYY-MM-DDTHH:mm').format(
						'YYYYMMDDHHmmss'
					)
				: '';
			params.reservedTo = state.reservedTo
				? moment(state.reservedTo, 'YYYY-MM-DDTHH:mm').format(
						'YYYYMMDDHHmmss'
					)
				: '';
		}
		[...state.aosList, ...state.iosList].forEach(list => {
			list.forEach(item => {
				if (item.src) params[item.id] = item.src;
			});
		});
		if (state.isConnectPopup === 1) {
			params.idPopup = state.idPopup;
		}
		return params;
	},
};

const mutations = {
	changeValues(state, values) {
		values.forEach(valueItem => {
			if (state.hasOwnProperty(valueItem.key))
				state[valueItem.key] = valueItem.value;
		});
	},
	img(state, args) {
		const setList = state[`${args.os}List`];
		if (!setList) return;
		const src = args.isDeleting ? null : args.src;
		state[`${args.os}List`] = setList.map(list => {
			return list.map(item => {
				if (item.id === args.id) item.src = src;
				return item;
			});
		});
	},
	init(state) {
		state.title = '';
		state.isReserved = 0;
		state.reservedFrom = '';
		state.reservedTo = '';
		state.aosList = _initImg(state.aosList);
		state.iosList = _initImg(state.iosList);
		state.isConnectPopup = 0;
		state.selectedPopupValue = '';
		state.selectedPopup = null;
	},
};

const actions = {
	post({ getters, rootState }) {
		const isValid = getters.validation('test');
		if (!isValid) return;
		const params = getters.getParams(rootState.login.name);
		axiosAdmin2
			.post('/api/splash/save', params)
			.then(({ data }) => {
				router.push({ path: '/advertisement/splash-manage' });
			})
			.catch(err => {
				console.error(err);
				alert('스플래시 등록에 실패 했습니다. 개발팀에 문의하세요.');
			});
	},
	get({ state }, id) {
		state.id = id;
		axiosAdmin2
			.get(`/api/splash/${id}`)
			.then(({ data }) => {
				data.doc = JSON.parse(data.doc) || {};
				state.isConnectPopup = data.isConnectPopup;
				if (state.isConnectPopup === 1) {
					state.selectedPopupValue = `(${data.popup.idPopup}) ${data.popup.popupTitle}`;
					state.idPopup = data.idPopup;
					state.selectedPopup = data.popup;
				}
				state.isReserved = data.isReserved;
				if (state.isReserved === 1) {
					state.reservedFrom = data.reservedFrom
						? moment(data.reservedFrom, 'YYYYMMDDHHmmss').format(
								'YYYY-MM-DDTHH:mm'
							)
						: '';
					state.reservedTo = data.reservedTo
						? moment(data.reservedTo, 'YYYYMMDDHHmmss').format(
								'YYYY-MM-DDTHH:mm'
							)
						: '';
				}
				state.title = data.title;
				state.aosList = _setImg(state.aosList, data.doc);
				state.iosList = _setImg(state.iosList, data.doc);
				state.getReady = true;
			})
			.catch(err => {
				console.error(err);
				alert(
					'스플래시 데이터 불러오기를 실패했습니다 개발팀에 문의하세요.'
				);
			});
	},
};

export default { namespaced: true, state, getters, mutations, actions };
